import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfiguration } from "@app/lib/services/app-config.service";
import { BaseHttpService } from "@app/lib/services/base-http.service";
import { ICasePhase, IParty, IPartyRequest } from "../models/party.model";
import { IResponse } from "@app/lib/models/response.model";
import { ICaseStatus, ICaseType } from "../models/case-status.model";
import { ICaseItem, ICaseSearchRequestBody, ICourtDivisionParam, ICourtUnitType, ISearchRequestParams } from "../models/case-assignment.model";
import { Observable } from "rxjs";
import { IJudgeLov, RoleItem, RoleStaff } from "../models/reports.model";

@Injectable({
    providedIn: 'root'
})
export class CourtStatsService extends BaseHttpService {

    constructor(
        http: HttpClient,
        appConfig: AppConfiguration,
    ) {
        super(http, appConfig);
    }

    getPartyNames(reqBody: IPartyRequest) {
        return this.post<IResponse<IParty[]>, IPartyRequest>('reports/common/search/parties/by/id/or/name.htm', reqBody);
    }

    searchCaseNumber(reqBody: ICaseSearchRequestBody, queryParams: ISearchRequestParams): Observable<IResponse<ICaseItem[]>> {
        return this.post<IResponse<ICaseItem[]>, ICaseSearchRequestBody>('case/search/by/case-number.htm', reqBody, { params: { ...queryParams } });
    }

    getCaseStatus() {
        return this.get<IResponse<ICaseStatus[]>>('reports/common/case/status.htm');
    }

    getCasePhases() {
        return this.get<IResponse<ICasePhase[]>>('reports/common/casephase/types.htm');
    }

    getDivisions() {
        return this.get<IResponse<ICourtUnitType[]>>('reports/common/court/unit/types/list.htm');
    }

    getCaseTypes() {
        return this.get<IResponse<ICaseType[]>>('reports/common/case/types/list.htm');
    }

    getCourtsByDivision(params: ICourtDivisionParam) {
        return this.get<IResponse<ICourtUnitType[]>>('reports/common/division.htm', { params: { ...params } });
    }

    //need to change
    getRoles() {
        return this.get<IResponse<RoleItem[]>>('ttRole-dtls/fetch/roles-lov.htm');
    }
    getCounelName(params: ICourtDivisionParam) {
        return this.get<IResponse<IParty[]>>('counselList/report/fetch/counselLOV-list.htm', { params: { ...params } });
    }
    //need to change
    getJudges() {
        const reqBody = { "reportFlag": "Y" }
        return this.post<IResponse<RoleItem[]>, any>('court-staff-assignment/fetch/roles-staff-lov.htm', reqBody);
    }
    getStaffName() {
        return this.get<IResponse<IParty[]>>('audit-trail/report/fetch/court-staff-users.htm');
    }
    getStaffNameSCN() {
        return this.get<IResponse<IParty[]>>('case-details/report/get/case-details-based-on-party-name.htm');
    }
    getStaffByRole(reqBody: RoleStaff) {
        return this.post<IResponse<IJudgeLov[]>, RoleStaff>('court-staff-assignment/fetch/staff-roles/lov/report.htm', reqBody);
    }

}